/* React */
import { useContext } from 'react'
import { LinkContainer } from 'react-router-bootstrap'

/* Bootstrap */
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'

/* FontAwesome */
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome'

import menu, { MenuItemLink, MenuItemDropdown } from './menu'
import { AppContext } from 'src/AppContext'
import { canSeeRoutePath } from 'src/routes/routeVisibility'
import { preloadRoutePath } from 'src/routes/preloadRoute'

const MenuLink: React.FC<MenuItemLink> = ({ title, icon, path }) => {
  const { haveRight } = useContext(AppContext)
  const preload = () => preloadRoutePath(path, haveRight)
  return <Nav.Item>
  <LinkContainer to={`/${path}`}>
    <Nav.Link onMouseEnter={preload} onFocus={preload}>
      <FontAwesome {...{ icon }} /> {title}
    </Nav.Link>
  </LinkContainer>
</Nav.Item>
}

const MenuDropdown: React.FC<MenuItemDropdown> = ({ title, icon, children:menu }) => {
  const { haveRight } = useContext(AppContext)
  return <NavDropdown
    title={<><FontAwesome {...{ icon }} /> {title}</>}
    menuVariant='dark'
  >

    {(menu as MenuItemLink[]).map(({path, icon, title}, index) => (
      <LinkContainer key={index} to={`/${path}`}>
        <NavDropdown.Item
          onMouseEnter={() => preloadRoutePath(path, haveRight)}
          onFocus={() => preloadRoutePath(path, haveRight)}
        >
          <FontAwesome {...{ icon }} fixedWidth /> {title}
        </NavDropdown.Item>
      </LinkContainer>
    ))}

  </NavDropdown>
}

const Menu: React.FC = () => {
  const { appState, haveRight } = useContext(AppContext)

  if (!appState.user) return <Nav navbar>
    {menu.map((item, index) => {
      const { path, children } = item

      if (path !== undefined) return <MenuLink key={index} {...(item as MenuItemLink)} />
      if (children)           return <MenuDropdown key={index} {...(item as MenuItemDropdown)} />

      return null
    })}
  </Nav>

  const visibleMenu = menu.reduce<typeof menu>((visibleItems, item) => {

    const { path, children } = item

    if (path !== undefined) {
      if (canSeeRoutePath(path, haveRight)) visibleItems.push(item)
      return visibleItems
    }

    if (children) {
      const visibleChildren = children.filter(child =>
        'path' in child && canSeeRoutePath(child.path, haveRight)
      )

      if (visibleChildren.length > 0) visibleItems.push({
        ...item,
        children: visibleChildren,
      })
    }

    return visibleItems

  }, [])

  return <Nav navbar>
    {visibleMenu.map((item, index) => {

      const { path, children } = item

      if (path !== undefined) return <MenuLink key={index} {...(item as MenuItemLink)} />
      if (children)           return <MenuDropdown key={index} {...(item as MenuItemDropdown)} />

      return null

    })}
  </Nav>

}

export default Menu
